module.exports = __webpack_public_path__ + "static/media/REDTAG-Sponsor.130994f5.jpg";